// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  background: transparent;
}

.hours-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hours-modal-wrapper {
  padding: 51px 27px 30px;
  font-size: 14px;
  z-index: 99;
}
@media screen and (max-width: 400px) {
  .hours-modal-wrapper {
    padding: 32px 15px;
  }
}
.hours-modal-wrapper .logo {
  height: 60px;
  margin-bottom: 20px;
}
.hours-modal-wrapper .close-btn {
  position: fixed;
  right: 20px;
  top: 20px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  z-index: 1;
}
@media screen and (max-width: 400px) {
  .hours-modal-wrapper .fees span {
    font-size: 9px;
  }
}
.hours-modal-wrapper .open-time {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  padding-inline: 70px;
}
.hours-modal-wrapper .open-time .open-time-name {
  font-family: AppFontBold;
  font-size: 18px;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--ion-color-primary);
  text-transform: uppercase;
  margin-bottom: 12px;
}
.hours-modal-wrapper .open-time .hours_text {
  font-family: AppFont;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
  color: black;
  margin-bottom: 5px;
}
.hours-modal-wrapper .open-time .open-time-texts {
  margin-bottom: 45px;
}
.hours-modal-wrapper .opening-time-wrapper,
.hours-modal-wrapper .delivery {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.hours-modal-wrapper .venue-name {
  font-family: AppFontBold;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.02em;
  text-align: left;
  color: black;
  text-align: center;
  margin-bottom: 5px;
}
.hours-modal-wrapper .address,
.hours-modal-wrapper .tel {
  font-family: AppFont;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.01em;
  text-align: center;
  color: black;
}
.hours-modal-wrapper .tel {
  margin-bottom: 17px;
}
.hours-modal-wrapper .separators {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.hours-modal-wrapper .separators .line {
  height: 8px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.hours-modal-wrapper .legal {
  margin-top: 16px;
  margin-bottom: 30px;
}
.hours-modal-wrapper .legal .pointer {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: black;
  text-decoration: underline;
  text-underline-offset: 5px;
}
.hours-modal-wrapper .first-fee {
  margin-bottom: 10px;
}
.hours-modal-wrapper .icon {
  width: 20px;
  margin-right: 9px;
}
.hours-modal-wrapper .time {
  display: block;
}
@media screen and (max-width: 320px) {
  .hours-modal-wrapper .time {
    font-size: 12px;
  }
}
.hours-modal-wrapper .bottom-start {
  position: absolute;
  left: 0;
  bottom: -145px;
  height: 300px;
  width: 103px;
}

.info {
  padding: 0;
}

.days {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: black;
}

.time {
  font-family: AppFont;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: black;
}

.info-row {
  width: 100%;
}

.info-row:first-child {
  margin-bottom: 14px;
}

.links_block {
  position: fixed;
  bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
}

.link {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  margin: 0;
  border-right-width: 2px;
  border-right-style: solid;
  border-image: linear-gradient(180deg, transparent 30%, #fff 30%, #fff 70%, transparent 70%);
  border-image-slice: 1;
  color: black;
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 121.4%; /* 19.424px */
  letter-spacing: 0.32px;
  text-decoration-line: underline;
  text-underline-offset: 0.2em;
  text-transform: capitalize;
}
.link:last-child {
  border-right: none;
}

.footer_img {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 50%;
  z-index: 1;
  overflow: hidden;
}
.footer_img ion-img {
  height: 100%;
  object-position: bottom;
  object-fit: fill;
}

.subtitle {
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
}

.info {
  color: var(--ion-color-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/working-hours-modal/working-hours-modal.component.scss"],"names":[],"mappings":"AAEA;EACC,uBAAA;AADD;;AAGC;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAAD;;AAEA;EACC,uBAAA;EACA,eAAA;EACA,WAAA;AACD;AAAC;EAJD;IAKE,kBAAA;EAGA;AACF;AAFC;EACC,YAAA;EACA,mBAAA;AAIF;AAFC;EACC,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AAIF;AACG;EADD;IAEE,cAAA;EAEF;AACF;AAEC;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAAF;AAEE;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAAA;EACA,mBAAA;AAAH;AAGE;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EAEA,kBAAA;AAFH;AAIE;EACC,mBAAA;AAFH;AAMC;;EAEC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAJF;AAOC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EAEA,kBAAA;AANF;AASC;;EAEC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAPF;AAWC;EACC,mBAAA;AATF;AAYC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAVF;AAWE;EACC,WAAA;EAEA,4BAAA;EACA,0BAAA;AAVH;AAcC;EACC,gBAAA;EACA,mBAAA;AAZF;AAiBE;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EAEA,0BAAA;EACA,0BAAA;AAhBH;AAoBC;EACC,mBAAA;AAlBF;AAqBC;EACC,WAAA;EACA,iBAAA;AAnBF;AAsBC;EACC,cAAA;AApBF;AAqBE;EAFD;IAGE,eAAA;EAlBD;AACF;AAqBC;EACC,kBAAA;EACA,OAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;AAnBF;;AAuBA;EACC,UAAA;AApBD;;AAuBA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AApBD;;AAwBA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AArBD;;AAwBA;EACC,WAAA;AArBD;;AAuBA;EACC,mBAAA;AApBD;;AAuBA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;AApBD;;AAsBA;EACC,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,2FAAA;EAOA,qBAAA;EAEA,YAAA;EAGA,wBAAA;EACA,eAAA;EACA,mBAAA,EAAA,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,4BAAA;EACA,0BAAA;AA5BD;AA8BC;EACC,kBAAA;AA5BF;;AA+BA;EACC,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AA5BD;AA8BC;EACC,YAAA;EACE,uBAAA;EACF,gBAAA;AA5BF;;AA+BA;EACC,iCAAA;EACA,oCAAA;AA5BD;;AA8BA;EACC,iCAAA;AA3BD","sourcesContent":["@import '../../../theme/mixins';\n\nbutton {\n\tbackground: transparent;\n}\n .hours-row {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n }\n.hours-modal-wrapper {\n\tpadding: 51px 27px 30px;\n\tfont-size: 14px;\n\tz-index: 99;\n\t@media screen and (max-width: 400px) {\n\t\tpadding: 32px 15px;\n\t}\n\t.logo {\n\t\theight: 60px;\n\t\tmargin-bottom: 20px;\n\t}\n\t.close-btn {\n\t\tposition: fixed;\n\t\tright: 20px;\n\t\ttop: 20px;\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tcursor: pointer;\n\t\tz-index: 1;\n\t}\n\n\t.fees {\n\t\tspan {\n\t\t\t@media screen and (max-width: 400px) {\n\t\t\t\tfont-size: 9px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.open-time {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tmargin-top: 25px;\n\t\tpadding-inline: 70px;\n\n\t\t.open-time-name {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 18px;\n\t\t\tline-height: 19px;\n\t\t\tletter-spacing: 0em;\n\t\t\ttext-align: left;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-bottom: 12px;\n\t\t}\n\n\t\t.hours_text {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 19px;\n\t\t\tletter-spacing: 0em;\n\t\t\ttext-align: center;\n\t\t\tcolor: black;\n\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t\t.open-time-texts {\n\t\t\tmargin-bottom: 45px;\n\t\t}\n\t}\n\n\t.opening-time-wrapper,\n\t.delivery {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t.venue-name {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 20px;\n\t\tline-height: 24px;\n\t\tletter-spacing: 0.02em;\n\t\ttext-align: left;\n\t\tcolor: black;\n\t\ttext-align: center;\n\n\t\tmargin-bottom: 5px;\n\t}\n\n\t.address,\n\t.tel {\n\t\tfont-family: AppFont;\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tletter-spacing: 0.01em;\n\t\ttext-align: center;\n\t\tcolor: black;\n\n\t}\n\n\t.tel {\n\t\tmargin-bottom: 17px;\n\t}\n\n\t.separators {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t\t.line {\n\t\t\theight: 8px;\n\t\t\t// background-image: url(../../../assets/losteria/dots-line.png);\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-size: 100% 100%;\n\t\t}\n\t}\n\n\t.legal {\n\t\tmargin-top: 16px;\n\t\tmargin-bottom: 30px;\n\n\t\t.pipe {\n\t\t}\n\n\t\t.pointer {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 20px;\n\t\t\tletter-spacing: 0em;\n\t\t\ttext-align: left;\n\t\t\tcolor: black;\n\n\t\t\ttext-decoration: underline;\n\t\t\ttext-underline-offset: 5px;\n\t\t}\n\t}\n\n\t.first-fee {\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.icon {\n\t\twidth: 20px;\n\t\tmargin-right: 9px;\n\t}\n\n\t.time {\n\t\tdisplay: block;\n\t\t@media screen and (max-width: 320px) {\n\t\t\tfont-size: 12px;\n\t\t}\n\t}\n\n\t.bottom-start {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tbottom: -145px;\n\t\theight: 300px;\n\t\twidth: 103px;\n\t}\n}\n\n.info {\n\tpadding: 0;\n}\n\n.days {\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\tline-height: 22px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\tcolor: black;\n\n}\n\n.time {\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 22px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\tcolor: black;\n\n}\n.info-row {\n\twidth: 100%;\n}\n.info-row:first-child {\n\tmargin-bottom: 14px;\n}\n\n.links_block {\n\tposition: fixed;\n\tbottom: 10px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tz-index: 99;\n}\n.link {\n\tflex-grow: 1;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcursor: pointer;\n\tpadding: 8px;\n\tmargin: 0;\n\tborder-right-width: 2px;\n\tborder-right-style: solid;\n\tborder-image: linear-gradient(\n\t\t180deg,\n\t\ttransparent  30%,\n\t\t#fff 30%,\n\t\t#fff 70%,\n\t\ttransparent  70%\n\t);\n\tborder-image-slice: 1;\n\n\tcolor: black;\n\n\n\tfont-family: AppFontBold;\n\tfont-size: 16px;\n\tline-height: 121.4%; /* 19.424px */\n\tletter-spacing: 0.32px;\n\ttext-decoration-line: underline;\n\ttext-underline-offset: 0.2em;\n\ttext-transform: capitalize;\n\n\t&:last-child {\n\t\tborder-right: none;\n\t}\n}\n.footer_img {\n\tposition: absolute;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\theight: 50%;\n\tz-index: 1;\n\toverflow: hidden;\n\n\tion-img {\n\t\theight: 100%;\n    object-position: bottom;\n\t\tobject-fit: fill;\n\t}\n}\n.subtitle {\n\tcolor: var(--ion-color-secondary);\n\tfont-family: AppFontBold, sans-serif;\n}\n.info {\n\tcolor: var(--ion-color-secondary);\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
